{
  "aNotificationWillBeSendToToAllLinkedPhoneNumbersWhenAnyOfTheseStateChangesOccurs": "Verrà inviata una notifica a tutti i numeri di telefono collegati quando si verifica una di queste modifiche di stato...",
  "aboutCustomNotifications": "Informazioni sulle notifiche personalizzate",
  "addYourPhoneNumber": "Aggiungi il tuo numero di telefono",
  "changesFrom": "cambia da:",
  "createNotificationHelpBodyText": "Per impostazione predefinita, FarmHQ tenterà di notificare tutti i membri del tuo account farm quando accade qualcosa di importante.\n\nSe vuoi ricevere notifiche personalizzate per dispositivi specifici, puoi impostare qui le regole di notifica.\n\nFarmHQ può notificarti quando un sensore sul tuo dispositivo cambia da uno stato all'altro. Assicurati che gli utenti del tuo account farm abbiano verificato i loro numeri di telefono nelle impostazioni del loro account.\n\nDevi avere l'autorizzazione per gestire le notifiche personalizzate per creare o eliminare le regole di notifica.",
  "deleteThisRule": "Eliminare questa regola?",
  "errorMessageAlreadyCreated": "Questa regola esiste già per questo dispositivo.",
  "newNotificationRule": "Nuova regola di notifica",
  "newRule": "Nuova regola",
  "noCustomNotificationRulesHaveBeenCreatedForThisDevice": "Non sono state create regole di notifica personalizzate per questo dispositivo.",
  "noVerifiedPhoneNumbersMessage": "Non hai numeri di telefono verificati. Puoi registrare e verificare i numeri di telefono nel menu delle impostazioni del tuo account.",
  "noVerifiedPhoneNumbersTitle": "Nessun numero di telefono verificato",
  "notificationRules": "Regole di notifica",
  "notifications": "Notifiche",
  "notificationsDisabled": "Notifiche disabilitate",
  "notificationsEnabled": "Notifiche abilitate",
  "sendANotificationToAllPhoneNumbersWhenThisStateChangeHappens": "Invia una notifica a tutti i numeri di telefono quando si verifica questo cambiamento di stato...",
  "sendANotificationWhen": "Invia una notifica quando...",
  "autoMutedExplanation": "Questo dispositivo è stato silenziato automaticamente perché inviava troppe notifiche. Puoi riattivarlo per riprendere a ricevere le notifiche.",
  "deviceMuted": "Dispositivo silenziato",
  "deviceMutedBanner": "Tutte le notifiche da questo dispositivo sono attualmente silenziate.",
  "muteDevice": "Silenzia dispositivo",
  "unmute": "Riattiva",
  "notificationChannel": "Canale di notifica",
  "notificationChannelDescription": "Scegli come ricevere le notifiche dai tuoi dispositivi.",
  "channelSms": "Solo SMS",
  "channelPush": "Solo push",
  "channelBoth": "SMS e push",
  "channelNone": "Nessuna",
  "channelPreferenceUpdated": "Preferenza del canale di notifica aggiornata.",
  "notificationMode": "Modalità di notifica",
  "notificationModeEnabled": "Abilitato",
  "notificationModeSuppressed": "Soppresso",
  "notificationPreferences": "Notification Preferences",
  "managePhoneNumbers": "Manage Phone Numbers",
  "manageNotificationsByDevice": "Manage Notifications by Device",
  "viewNotificationMap": "View on Map",
  "notificationMapTitle": "Notification Map",
  "legendEnabled": "Attivo",
  "legendSuppressed": "Silenziato per me",
  "legendMuted": "Silenziato per tutti",
  "noDevicesMessage": "No devices found.",
  "personalPreferencesOnly": "These preferences apply only to your account.",
  "manageDevicesDescription": "These settings only affect your notifications. Other users' preferences are not changed.",
  "affectsOnlyYou": "This setting affects only your notifications.",
  "muteForAllUsers": "Mute for All Users",
  "muteForAllUsersDescription": "When muted, no users will receive notifications from this device.",
  "mutedByUserAt": "Muted by {{email}} on {{date}}.",
  "autoMutedAt": "Automatically muted on {{date}} due to excessive notifications.",
  "notificationSettings": "Notification Settings",
  "muteForMe": "Mute for Me",
  "muteForMeDescription": "Mute notifications from this device for your account only.",
  "mutedForMe": "Muted for you",
  "unmutedForMe": "Unmuted for you",
  "deviceMuteStatus": "Device Mute",
  "stateEnabled": "Attivo",
  "stateMutedForMe": "Silenziato per me",
  "stateMutedForAll": "Silenziato per tutti",
  "disabledByAdmin": "Notifiche disabilitate da un amministratore.",
  "sendTestNotification": "Invia notifica di prova",
  "sendTestNotificationQuestion": "Inviare una notifica di prova?",
  "sendTestToMe": "Invia una prova a me",
  "sendTestToFarm": "Invia una prova a tutti",
  "testNotificationDescription": "Invia a te stesso una prova per verificare che le notifiche funzionino, oppure prova con tutti gli utenti della tua azienda agricola.",
  "testNotificationFarmWarning": "Tutti gli utenti di questa azienda agricola riceveranno questa notifica di prova, secondo le proprie impostazioni di notifica.",
  "testNotificationDeviceWarning": "Tutti gli utenti configurati per ricevere notifiche da questo dispositivo riceveranno questa notifica di prova.",
  "testNotificationSent_one": "Notifica di prova inviata a {{count}} destinatario.",
  "testNotificationSent_other": "Notifica di prova inviata a {{count}} destinatari.",
  "testNotificationPermissionRequired": "Serve l'autorizzazione a gestire le notifiche dei dispositivi per provare con tutti gli utenti della tua azienda agricola."
}
